"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _UA = _interopRequireDefault(require("../UA"));

var _ENUMS = _interopRequireDefault(require("../ENUMS"));

var getISSClientId = function getISSClientId() {
  var defaultClientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ENUMS["default"].HEADER_CLIENT_ID.iss_user_wap;
  var clientID = defaultClientId;

  if (_UA["default"].env.alipay) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_alipayapp;
  } else if (_UA["default"].env.hwquickApp) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.hw_user_app;
  } else if (_UA["default"].env.swanApp) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_bdapp;
  } else if (_UA["default"].env.weiXin || _UA["default"].env.wxMiniProgram) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_wxapp;
  } else if (_UA["default"].env.shanSong_redBookMini) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_redbook;
  } else if (_UA["default"].env.shanSong_sellerApp) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.shop_app;
  } else if (_UA["default"].env.shanSongApp) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_app;
  } else if (_UA["default"].env.douYinMini) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_ttapp;
  } else if (_UA["default"].env.douYin) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_marketing_douyin;
  }

  if (_UA["default"].env.shanSong_courierApp) {
    clientID = _ENUMS["default"].HEADER_CLIENT_ID.iss_courier;
  }

  return clientID;
};

var getClientId = function getClientId() {
  var defaultClientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ENUMS["default"].HEADER_CLIENT_ID.iss_user_marketing;
  var clientId = defaultClientId;

  if (_UA["default"].env.shanSongApp) {
    if (_UA["default"].env.shanSong_sellerApp) {
      clientId = _ENUMS["default"].HEADER_CLIENT_ID.shop_app;
      return clientId;
    }

    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_app;
    return clientId;
  }

  if (_UA["default"].env.weiXin || _UA["default"].env.wxMiniProgram) {
    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_wxapp;
    return clientId;
  }

  if (_UA["default"].env.shanSong_redBookMini) {
    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_redbook;
    return clientId;
  }

  if (_UA["default"].env.alipay) {
    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_alipayapp;
    return clientId;
  }

  if (_UA["default"].env.swanApp) {
    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_bdapp;
    return clientId;
  }

  if (_UA["default"].env.douYinMini) {
    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_ttapp;
    return clientId;
  }

  if (_UA["default"].env.douYin) {
    clientId = _ENUMS["default"].HEADER_CLIENT_ID.iss_user_marketing_douyin;
    return clientId;
  }

  return clientId;
};

var _default = {
  getClientId: getClientId,
  getISSClientId: getISSClientId
};
exports["default"] = _default;